import React from "react";
import { Button, Collapse, Icon } from "antd";
import { Link, graphql, StaticQuery } from "gatsby";
import Layout from "../../components/TheLayout";
import { node } from "prop-types";
const Panel = Collapse.Panel;

const Collaborator = ({ name, institution }) => {
  return (
    <div>
      <h3
        style={{
          display: "inline",
          marginRight: "5px",
          fontWeight: "600",
          color: "#474487"
        }}
      >
        {name}
      </h3>
      <span> - {institution}</span>
    </div>
  );
};
const CollaborationsPage = () => {
  return (
    <Layout>
      <div
        style={{
          maxWidth: "65%",
          margin: "20px auto",
          textAlign: "center"
        }}
      >
        <h1 style={{ color: "#474487" }}>Collaborations</h1>
        <p>
          The different personalities, backgrounds and experience in our group
          combine into a rich knowledge-seeking atmosphere. As a collaborative
          team of organic chemists, biochemists, and biologists we strive to
          advance our existing collaborations and continuously welcome new ones.
        </p>
        <Button type="primary" ghost>
          <Link to="/contactus">Contact us</Link>
        </Button>
      </div>
      <StaticQuery
        query={graphql`
          query {
            allMarkdownRemark(
              filter: { frontmatter: { templateKey: { eq: "collaborations" } } }
              sort: { fields: frontmatter___title, order: DESC }
            ) {
              edges {
                node {
                  frontmatter {
                    title
                    collaborations {
                      info
                      institution
                      link
                      title
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { edges: collaborationCategories } = data.allMarkdownRemark;
          return (
            <Collapse
              style={{ margin: "auto 16px" }}
              className="collaborations"
              defaultActiveKey={["0", "1"]}
            >
              {collaborationCategories.map((category, index) => (
                <Panel header={category.node.frontmatter.title} key={index}>
                  <Collapse accordion>
                    {category.node.frontmatter.collaborations.map(
                      collaborator => {
                        if (collaborator.title) {
                          return (
                            <Panel
                              header={
                                <Collaborator
                                  name={collaborator.title}
                                  institution={collaborator.institution}
                                />
                              }
                            >
                              <p>{collaborator.info}</p>
                              {collaborator.link && (
                                <p>
                                  <a href={collaborator.link}>More info</a>
                                </p>
                              )}
                            </Panel>
                          );
                        }
                      }
                    )}
                  </Collapse>
                </Panel>
              ))}
            </Collapse>
          );
        }}
      />
    </Layout>
  );
};

export default CollaborationsPage;
